import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { TERMS_OF_SERVICE } from '@/constants/legal';

export default function TermsScreen() {
  return (
    <ScrollView style={s.container} contentContainerStyle={s.content}>
      <View style={s.header}>
        <Text style={s.brand}>MAXIFY</Text>
        <Text style={s.title}>{TERMS_OF_SERVICE.title}</Text>
      </View>
      {TERMS_OF_SERVICE.sections.map((section, i) => (
        <View key={i} style={s.section}>
          <Text style={s.heading}>{section.heading}</Text>
          <Text style={s.body}>{section.body}</Text>
        </View>
      ))}
      <View style={s.footer} />
    </ScrollView>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  content: { paddingHorizontal: 24, paddingTop: 56, paddingBottom: 80, maxWidth: 720, alignSelf: 'center', width: '100%' },
  header: { marginBottom: 40, borderBottomWidth: 1, borderBottomColor: '#e5e5e5', paddingBottom: 24 },
  brand: { fontSize: 13, fontWeight: '700', letterSpacing: 3, color: '#111', marginBottom: 8 },
  title: { fontSize: 28, fontWeight: '700', color: '#111', lineHeight: 34 },
  section: { marginBottom: 28 },
  heading: { fontSize: 15, fontWeight: '700', color: '#111', marginBottom: 8, lineHeight: 20 },
  body: { fontSize: 14, color: '#444', lineHeight: 22 },
  footer: { height: 40 },
});
